import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAuthoringlogo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M34.8529 0H5.14706C2.30147 0 0 2.30147 0 5.14706V34.8529C0 37.6985 2.30147 40 5.14706 40H34.8529C37.6985 40 40 37.6985 40 34.8529V5.14706C40 2.30147 37.6985 0 34.8529 0Z",
			fill: "url(#paint0_linear_1812_508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2917 24.7083V20.5417L25.7084 10.125L29.875 14.2917L19.4584 24.7083H15.2917Z",
			fill: "white",
			fillOpacity: .3,
			stroke: "white",
			strokeWidth: 2.08333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.125 28.875H29.875",
			stroke: "#21ADBE",
			strokeWidth: 2.08333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5833 13.25L26.75 17.4167",
			stroke: "white",
			strokeWidth: 2.08333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1812_508",
			x1: 12.4551,
			y1: 2.30882,
			x2: 29.514,
			y2: 42.3088,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#005C71" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#02252D"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgIconAuthoringlogo);
export default ForwardRef;
